<h3 mat-dialog-title>{{ data.title }}</h3>
<mat-dialog-content>
  <form class="form" [formGroup]="fg" (ngSubmit)="onSubmit()" #myForm="ngForm">
    <mat-form-field appearance="fill">
      <mat-label>{{ data.label }}</mat-label>
      <input matInput formControlName="date" [matDatepicker]="picker" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </form>
</mat-dialog-content>
<div mat-dialog-actions [align]="'start'">
  <button (click)="myForm.ngSubmit.emit()" color="primary" mat-raised-button>
    {{ data.buttonText }}
  </button>
  <button mat-dialog-close type="button" mat-button>Cancel</button>
</div>
